import React, { useState, useRef, useEffect } from "react";
import { Button, Alert } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import "./qsetprestart.scss";

function QsetPreStart() {
  const { ev_id } = useParams();
  const navigate = useNavigate();

  // idle | requesting | granted | denied
  const [permStatus, setPermStatus] = useState("idle");
  const streamRef = useRef(null);

  // Stop the camera stream when leaving this page — we only needed it
  // to trigger/confirm the permission grant, not to keep the camera on here.
  useEffect(() => {
    return () => {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach((track) => track.stop());
      }
    };
  }, []);

  const requestCameraPermission = async () => {
    setPermStatus("requesting");
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      streamRef.current = stream;
      setPermStatus("granted");
    } catch (err) {
      console.error("Camera permission error:", err);
      setPermStatus("denied");
    }
  };

  const startExam = () => {
    // Stop the pre-check stream before navigating; the exam page will
    // request its own stream, but permission is already granted so
    // the browser won't show a prompt this time.
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }
    navigate(`/qsethome/qset/qsetcandidateexamcardlist/${ev_id}`);
  };

  return (
    <div className="evaluation-consent">
      <div>
        <h2>Ready to Start Your Exam?</h2>
        <p>This exam requires your camera and will enter fullscreen mode.</p>

        {permStatus === "denied" && (
          <Alert
            type="error"
            showIcon
            message="Camera access denied"
            description="Please allow camera access in your browser settings and try again. You cannot start the exam without camera access."
            style={{ marginBottom: 16 }}
          />
        )}

        {permStatus === "granted" && (
          <Alert
            type="success"
            showIcon
            message="Camera access granted"
            style={{ marginBottom: 16 }}
          />
        )}

        {permStatus !== "granted" || permStatus === "denied" ? (
          <Button
            type="primary"
            loading={permStatus === "requesting"}
            onClick={requestCameraPermission}
            hidden={permStatus === "denied"}
          >
            {permStatus === "denied"
              ? "Retry Camera Access"
              : "Allow Camera Access"}
          </Button>
        ) : (
          <Button type="primary" onClick={startExam}>
            Click to Start
          </Button>
        )}
      </div>
    </div>
  );
}

export default QsetPreStart;
